import { PopoverBody as _PopoverBody, PopoverBodyProps as _PopoverBodyProps } from "reactstrap";

    export const PopoverBody = _PopoverBody;
    export type PopoverBodyProps = _PopoverBodyProps;
    